
import { Component, Vue } from 'vue-property-decorator';
import { load } from 'recaptcha-v3';

@Component
export default class ReCAPTCHA extends Vue {
  private action = '';

  /**
   * reCAPTCHAのトークン取得
   * @param action アクション名
   */
  async getToken(action: string) {
    this.action = action;
    const recaptcha = await load(String(process.env.VUE_APP_RE_CAPTCHA_SITE_KEY));
    return recaptcha.execute(this.action);
  }
}
